import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';

export const useShipmentStatuses = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  const {
    data: shipmentStatuses = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['shipment-statuses'],
    queryFn: () => adapter.fetchShipmentStatuses(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    shipmentStatuses,
    isLoading,
    error,
    refetch,
  };
};
